export default "__VITE_ASSET__Ru9dotvT__"